import { DateTime } from "luxon";
import { IVisitSalesItemPublicModel, VisitSalesItemPublicModel } from ".";

export interface IVisitPublicModel {
    visitPublicId: string;
    visitDate: string;
    clientFirstName: string;
    clientLastName: string;
    clientEmailAddress: string;
    clientPhone: string;
    clientAddress: string;
    clientAddress2: string;
    clientCity: string;
    clientStateAbbreviation: string;
    clientZipCode: string;
    clientCounty: string;
    petName: string;
    petSpeciesName: string;
    petGenderName: string;
    petBreedName: string;
    petBirthDate: string;
    petWeight: number;
    salesPackageId: number | undefined;
    salesPackagePrice: number | undefined;
    salesPackageName: string | undefined;
    salesPackageDiscountAmount: number | undefined;
    salesPackageInvoicePrice: number | undefined;
    storeCode: string;
    storeName: string;
    storeAddress: string;
    storeAddress2: string;
    storeCity: string;
    storeStateAbbreviation: string;
    storeZipCode: string;
    storePhone: string;
    storeSecondaryPhone: string;
    storeBrandName: string;
    storePartnerName: string;
    storePartnerLabel: string;
    storeTimezoneName: string;
    storeLatitude: number;
    storeLongitude: number;
    vetFirstName: string;
    vetLastName: string;
    vetEmail: string;
    vetLicenseNumber: string;
    vetLicenseStateAbbreviation: string;
    vetLicenseExpirationDate: string;
    vetLicenseLicenseTypeName: string;
    hospitalName: string;
    hospitalCode: string;
    hospitalPhone: string;
    visitSalesItems: IVisitSalesItemPublicModel[];
}

export class VisitPublicModel implements Record<keyof IVisitPublicModel, any> {
    visitPublicId: string;
    visitDate: DateTime;
    clientFirstName: string;
    clientLastName: string;
    clientEmailAddress: string;
    clientPhone: string;
    clientAddress: string;
    clientAddress2: string;
    clientCity: string;
    clientStateAbbreviation: string;
    clientZipCode: string;
    clientCounty: string;
    petName: string;
    petSpeciesName: string;
    petGenderName: string;
    petBreedName: string;
    petBirthDate: string; // intentionally left as string so it can be parsed and pretty-printed.
    petWeight: number;
    salesPackageId: number | undefined;
    salesPackagePrice: number | undefined;
    salesPackageName: string | undefined;
    salesPackageDiscountAmount: number | undefined;
    salesPackageInvoicePrice: number | undefined;
    storeCode: string;
    storeName: string;
    storeAddress: string;
    storeAddress2: string;
    storeCity: string;
    storeStateAbbreviation: string;
    storeZipCode: string;
    storePhone: string;
    storeSecondaryPhone: string;
    storeBrandName: string;
    storePartnerName: string;
    storePartnerLabel: string;
    storeTimezoneName: string;
    storeLatitude: number;
    storeLongitude: number;
    vetFirstName: string;
    vetLastName: string;
    vetEmail: string;
    vetLicenseNumber: string;
    vetLicenseStateAbbreviation: string;
    vetLicenseExpirationDate: DateTime;
    vetLicenseLicenseTypeName: string;
    hospitalName: string;
    hospitalCode: string;
    hospitalPhone: string;
    visitSalesItems: VisitSalesItemPublicModel[];

    constructor(params: IVisitPublicModel) {
        this.visitPublicId = params.visitPublicId;
        this.visitDate = DateTime.fromISO(params.visitDate, { zone: 'utc' });
        this.clientFirstName = params.clientFirstName;
        this.clientLastName = params.clientLastName;
        this.clientEmailAddress = params.clientEmailAddress;
        this.clientPhone = params.clientPhone;
        this.clientAddress = params.clientAddress;
        this.clientAddress2 = params.clientAddress2;
        this.clientCity = params.clientCity;
        this.clientStateAbbreviation = params.clientStateAbbreviation;
        this.clientZipCode = params.clientZipCode;
        this.clientCounty = params.clientCounty;
        this.petName = params.petName;
        this.petSpeciesName = params.petSpeciesName;
        this.petGenderName = params.petGenderName;
        this.petBreedName = params.petBreedName;
        this.petBirthDate = params.petBirthDate; // intentionally left as string so it can be parsed and pretty-printed.
        this.petWeight = params.petWeight;
        this.salesPackageId = params.salesPackageId;
        this.salesPackageName = params.salesPackageName;
        this.salesPackagePrice = params.salesPackagePrice
        this.salesPackageDiscountAmount = params.salesPackageDiscountAmount
        this.salesPackageInvoicePrice = params.salesPackageInvoicePrice;
        this.storeCode = params.storeCode;
        this.storeName = params.storeName;
        this.storeAddress = params.storeAddress;
        this.storeAddress2 = params.storeAddress2;
        this.storeCity = params.storeCity;
        this.storeStateAbbreviation = params.storeStateAbbreviation;
        this.storeZipCode = params.storeZipCode;
        this.storePhone = params.storePhone;
        this.storeSecondaryPhone = params.storeSecondaryPhone;
        this.storeBrandName = params.storeBrandName;
        this.storePartnerName = params.storePartnerName;
        this.storePartnerLabel = params.storePartnerLabel;
        this.storeTimezoneName = params.storeTimezoneName;
        this.storeLatitude = params.storeLatitude;
        this.storeLongitude = params.storeLongitude;
        this.vetFirstName = params.vetFirstName;
        this.vetLastName = params.vetLastName;
        this.vetEmail = params.vetEmail;
        this.vetLicenseNumber = params.vetLicenseNumber;
        this.vetLicenseStateAbbreviation = params.vetLicenseStateAbbreviation;
        this.vetLicenseExpirationDate = DateTime.fromISO(params.vetLicenseExpirationDate, { zone: 'utc' });
        this.vetLicenseLicenseTypeName = params.vetLicenseLicenseTypeName;
        this.hospitalName = params.hospitalName;
        this.hospitalCode = params.hospitalCode;
        this.hospitalPhone = params.hospitalPhone;
        this.visitSalesItems = (params.visitSalesItems ?? []).map(vsi => new VisitSalesItemPublicModel(vsi));
    }
}
